<template>
    <div class="page-content">
        <el-row class="search-title common-table-top el-row">
            <el-col :span="4" style="text-align: left;">
                <i class="el-icon-document" style="color: #4882ff;font-size: 18px;font-weight: bold;margin-left: 10px"></i>
                <span class="order-list-search-span" style="margin-left: 6px">添加活动</span>
            </el-col>
            <el-col :span="20" class="text-align-right">
            </el-col>
        </el-row>
        <el-row class="box-content">
            <div class="box-content-div form-submit-page">
                <el-form :inline="false" :model="formInline" ref="ruleForm" :rules="rules" class="box-content-form" label-width="100px" style="width:auto">
                    <el-form-item label="活动名称:" prop="title">
                        <el-input v-model="formInline.title" placeholder="请输入活动名称"></el-input>
                    </el-form-item>
                    <el-form-item label="类型:" prop="type">
                        <el-select v-model="formInline.type" placeholder="请选择">
                            <el-option
                                    v-for="item in typeOptions"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                  <!--积分-->
                  <el-form-item label="积分:" prop="gift" v-if="formInline.type === 1">
                    <el-input v-model="formInline.gift" type="number" placeholder="请输入分值"></el-input>
                  </el-form-item>
                  <!--实物-->
                  <!--<el-form-item label="实物:" prop="gift" v-if="formInline.type === 2">-->
                    <!--<el-input v-model="formInline.gift" placeholder="请输入礼品名称"></el-input>-->
                  <!--</el-form-item>-->
                  <el-form-item label="奖品名称:" prop="gift"  v-if="formInline.type === 2">
                    <el-input v-model="formInline.gift" placeholder="请填写赠送的实物名称"></el-input>
                  </el-form-item>
                  <!--优惠券-->
                  <el-form-item label="领券地址:" prop="gift" v-if="formInline.type === 3">
                    <el-input v-model="formInline.gift" placeholder="请输入领券地址"></el-input>
                  </el-form-item>
                  <!--游戏-->
                  <el-form-item label="游戏地址:" prop="gift" v-if="formInline.type === 4">
                    <el-input v-model="formInline.gift" placeholder="请输入游戏地址"></el-input>
                  </el-form-item>
                  <el-form-item label="奖品编码:" prop="pro_code" v-if="formInline.type === 2">
                    <el-input v-model="formInline.pro_code" placeholder="请填写赠送的实物编码"></el-input>
                  </el-form-item>
                    <el-form-item label="奖品名称:" prop="pro_code" v-else>
                        <el-input v-model="formInline.pro_code" placeholder="请输入奖品说明"></el-input>
                    </el-form-item>
                    <el-form-item label="开始时间:" prop="start">
                        <el-date-picker style="width:193px;"
                                        v-model="formInline.start"
                                        type="datetime"
                                        placeholder="开始时间"
                                        value-format="yyyy-MM-dd HH:mm:ss">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="结束时间:" prop="end">
                        <el-date-picker style="width:193px;"
                                        v-model="formInline.end"
                                        type="datetime"
                                        placeholder="结束时间"
                                        value-format="yyyy-MM-dd HH:mm:ss">
                        </el-date-picker>
                    </el-form-item>
                    <!--<el-form-item label="备注:" prop="remark">-->
                        <!--<el-input v-model="formInline.remark" placeholder="请填写备注"></el-input>-->
                    <!--</el-form-item>-->
                    <el-form-item>
                        <el-button class="second-page-btn" style="margin-right:78px;float:left" type="primary" @click="addRegisterAction">保存</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </el-row>
    </div>
</template>
<script>
import { addRegister } from '@/api/customer.js'
export default {
  name: 'addRegisterPolite',
  data () {
    return {
      typeOptions: [
        {
          value: 1,
          label: '积分'
        },
        {
          value: 2,
          label: '实物'
        },
        {
          value: 3,
          label: '优惠券'
        },
        {
          value: 4,
          label: '游戏'
        }
      ],
      formInline: {
        type: '',
        start: '',
        end: '',
        gift: '',
        remark: '',
        title: '',
        pro_code: ''
      },
      rules: {
        type: [
          { required: true, message: '请选择活动类型', trigger: 'blur' }
        ],
        title: [
          { required: true, message: '请填写活动标题', trigger: 'blur' }
        ],
        gift: [
          { required: true, message: '请填写奖品名称', trigger: 'blur' }
        ],
        start: [
          { required: true, message: '请选择活动开始时间', trigger: 'blur' }
        ],
        end: [
          { required: true, message: '请选择活动结束时间', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          alert('submit!')
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
    addRegisterAction() {
      addRegister(this.formInline).then(res => {
        if (res.data.code === 0) {
          _g.toastMsg('success', res.data.error)
          router.push('/home/register-polite')
        } else {
          _g.toastMsg('error', res.data.error)
        }
      })
    }
  },
  created() {},
  mounted() {}
}
</script>

<style scoped>

    .content-one span {
        display: inline-block;
        float: left;
        line-height: 20px;
        font-size: 16px;
        margin-top: 10px;
    }
    .content-one p {
        text-align: left;
    }
    .box-content-div {
      width: 550px !important;
      margin:0 auto;
      box-sizing: border-box;
    }
    .box-content-form {
        margin-top: 30px;
        text-align: center;
        float:left;
    }
    .box-content-form .el-form-item {
        width: 300px;
        margin: 0 auto 22px;
    }
    .explain_question {
        width:25px;
        height:35px;
        line-height: 35px;
        border:1px solid #ddd;
        border-radius: 5px;
        color:#b4b4b4;
        position:absolute;
        top:2%;
        right:-30px;
        z-index: 100;
    }
    .type_explain {
        width:300px;
        height:80px;
        line-height: 20px;
        text-align: left;
        border:1px solid #ddd;
        border-radius: 10px;
        padding:10px;
        color:#606266;
        position:absolute;
        top:2%;
        left:110%;
        display:none;
    }
    .explain_question:hover .type_explain{
       display:block;
    }
</style>
